// Phone & WhatsApp constants + helpers
export const PHONE_DISPLAY = "240-761-8778";
export const PHONE_TEL = "+12407618778";
export const WHATSAPP_BASE = "https://wa.me/12407618778";

export const buildWhatsAppUrl = (message) => {
  if (!message) return WHATSAPP_BASE;
  return `${WHATSAPP_BASE}?text=${encodeURIComponent(message)}`;
};
